import React, { useCallback, useRef, useState } from "react";
import { Box, Fade, Tabs, Tab } from "@mui/material";
import { TabContext, TabPanel } from "@mui/lab";
import FormBlockBrowser from "./FormBlockBrowser";
import FormFieldPanel from "./FormFieldPanel";

const MIN_WIDTH = 270;
const MAX_WIDTH = 600;
const DEFAULT_WIDTH = 330;

const PDFEditorLeftPanel = ({
  currentProcessingFile,
  setCurrentProcessingFile,
  isOpen,
  onNotify,
  loading,
}) => {
  const [tabValue, setTabValue] = useState("1");
  const [width, setWidth] = useState(DEFAULT_WIDTH);
  const isResizing = useRef(false);
  const startX = useRef(0);
  const startWidth = useRef(0);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const onMouseDown = useCallback(
    (e) => {
      isResizing.current = true;
      startX.current = e.clientX;
      startWidth.current = width;

      document.body.style.cursor = "col-resize";
      document.body.style.userSelect = "none";

      const onMouseMove = (e) => {
        if (!isResizing.current) return;
        const delta = e.clientX - startX.current;
        const newWidth = Math.min(
          MAX_WIDTH,
          Math.max(MIN_WIDTH, startWidth.current + delta),
        );
        setWidth(newWidth);
      };

      const onMouseUp = () => {
        isResizing.current = false;
        document.body.style.cursor = "";
        document.body.style.userSelect = "";
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    },
    [width],
  );

  return (
    <Fade in>
      <Box sx={{ display: "flex", position: "relative" }}>
        <Box
          sx={{
            width: isOpen ? width : 0,
            minWidth: isOpen ? MIN_WIDTH : 0,
            maxWidth: isOpen ? MAX_WIDTH : 0,
            bgcolor: "background.paper",
            height: "calc(100vh - 200px)",
            flexShrink: 0,
            overflow: "hidden",
          }}
        >
          <TabContext value={tabValue}>
            <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
              <Tabs
                value={tabValue}
                onChange={handleChange}
                centered
                variant="fullWidth"
              >
                <Tab label="Form Sections" value="1" />
                <Tab label="Form Fields" value="2" />
              </Tabs>
            </Box>
            <TabPanel
              value="1"
              sx={{ padding: "0px !important", height: "100%" }}
            >
              <FormBlockBrowser
                currentProcessingFile={currentProcessingFile}
                setCurrentProcessingFile={setCurrentProcessingFile}
                onNotify={onNotify}
                loading={loading}
              />
            </TabPanel>
            <TabPanel
              value="2"
              sx={{ padding: "0px !important", height: "100%" }}
            >
              <FormFieldPanel
                currentProcessingFile={currentProcessingFile}
                setCurrentProcessingFile={setCurrentProcessingFile}
                onNotify={onNotify}
                loading={loading}
              />
            </TabPanel>
          </TabContext>
        </Box>
        <Box
          onMouseDown={onMouseDown}
          sx={{
            width: 5,
            cursor: "col-resize",
            bgcolor: "transparent",
            borderRight: "1px solid #E5E7EB",
            flexShrink: 0,
            transition: "background-color 0.15s",
            "&:hover": {
              bgcolor: "primary.main",
              opacity: 0.4,
            },
            "&:active": {
              bgcolor: "primary.main",
              opacity: 0.6,
            },
          }}
        />
      </Box>
    </Fade>
  );
};

export default PDFEditorLeftPanel;
